module.exports = __webpack_public_path__ + "static/media/dell_logo.8f62517b.jpg";